__turbopack_context__.v({
  "container": "ToggleField-module__RB9Y_a__container",
  "fadeInItems": "ToggleField-module__RB9Y_a__fadeInItems",
  "spacing--lg": "ToggleField-module__RB9Y_a__spacing--lg",
  "spacing--md": "ToggleField-module__RB9Y_a__spacing--md",
  "spacing--sm": "ToggleField-module__RB9Y_a__spacing--sm",
  "spacing--xl": "ToggleField-module__RB9Y_a__spacing--xl",
  "spacing--xs": "ToggleField-module__RB9Y_a__spacing--xs",
  "spacing--xxl": "ToggleField-module__RB9Y_a__spacing--xxl",
  "spacing--xxs": "ToggleField-module__RB9Y_a__spacing--xxs",
  "spacing--xxxl": "ToggleField-module__RB9Y_a__spacing--xxxl",
  "spacing--xxxs": "ToggleField-module__RB9Y_a__spacing--xxxs",
  "toggled": "ToggleField-module__RB9Y_a__toggled",
});
